module.exports = __webpack_public_path__ + "img/1558611.a36a1cd8.svg";